(() => {
  const publishContactEvent = (link) => {
    const platform = link.dataset.contactPlatform || 'unknown';
    const eventName = platform === 'line' ? 'line_contact_click' : 'social_outbound_click';
    const eventData = {
      social_platform: platform,
      link_placement: link.dataset.contactPlacement || 'unknown',
      link_url: link.href,
      page_location: window.location.href,
      page_path: window.location.pathname,
    };

    try {
      window.Shopify?.analytics?.publish?.(eventName, eventData);
    } catch (_error) {
      // Contact navigation must never be blocked by analytics.
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventData);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventData });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('[data-social-contact]');
    if (!(link instanceof HTMLAnchorElement)) return;

    publishContactEvent(link);
  });
})();
